<script lang="ts">
  import type { Image } from "../../../types/CinemaProductsDto.types.ts";
  import type { Snippet } from "svelte";

  type ProductImageProps = {
    image: Image;
    lazyLoad: boolean;
    children: Snippet;
  };

  let { image, lazyLoad, children }: ProductImageProps = $props();

  let imageLoaded = $state(false);
  let loadingError = $state(false);

  const SPA_AMBIENT_PRESET = "$spa_ambiente$";
  const TILE_PORTRAIT_PRESET = "$tile_portrait$";

  function getImageUrl(): string {
    const queryParam =
      image.clippingType === "AMBIENTE" ? SPA_AMBIENT_PRESET : TILE_PORTRAIT_PRESET;
    return `${image.url}?${queryParam}`;
  }

  const imgSrc = $derived(getImageUrl());
</script>

<div class="cinema-product-image" style:aspect-ratio="3/4">
  <picture>
    {#if !loadingError}
      <source srcset="{imgSrc}&fmt=auto" />
    {/if}
    <img
      loading={lazyLoad ? "lazy" : "eager"}
      data-src={imgSrc}
      src={lazyLoad ? "" : imgSrc}
      alt={image.alt}
      class={image.clippingType === "AMBIENTE" ? "ambient" : "cutout"}
      class:loaded={imageLoaded}
      onload={() => (imageLoaded = true)}
      onerror={() => {
        loadingError = true;
      }}
    />
  </picture>

  {@render children()}

  {#if !imageLoaded}
    <div class="cinema-product-image__spinner">
      <oc-spinner-v1 size={/*                      */ "200"} variant="default"></oc-spinner-v1>
    </div>
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .cinema-product-image {
    display: block;
    height: 100%;
    width: 100%;
    position: relative;
    overflow: hidden;
    max-width: 100%;
    background-color: white;

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: fill;
      border-radius: inherit;
      display: block;
      max-width: 100%;
      max-height: 100%;
      opacity: 0;
      transition: opacity 0.3s ease;

      &.loaded {
        opacity: 1;
      }
    }

    img.ambient {
      min-width: 100%;
      min-height: 100%;
      max-width: none;
      border-radius: tokens.$oc-semantic-border-radius-200;
    }

    img.cutout {
      padding: 8px;
      border-radius: tokens.$oc-semantic-border-radius-200;
    }

    &__spinner {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
</style>
